import { BookOpenIcon, CheckBadgeIcon, UserIcon, ViewfinderCircleIcon } from "@heroicons/react/20/solid";

const DemoHomePageCard = ({ text, Icon, href }) => {
  return (
    <a href={href} className="rounded-md bg-perception-gray-800 p-4 w-[500px]
      flex flex-col gap-4 justify-center items-center text-3xl text-white
      hover:scale-105 transition hover:bg-perception-blue">
      <Icon className="size-24"/>
      {text}
    </a>
  );
};

export const DemoHomePage = () => {

  return (
    <div className="bg-perception-black-800 px-72 h-full flex justify-center items-center">
      <div className="h-[500px] grid grid-cols-2 gap-8">
        <DemoHomePageCard text="Suivi d'opérations" Icon={CheckBadgeIcon} href="/interface/live"/>
        <DemoHomePageCard text="Contrôle qualité" Icon={ViewfinderCircleIcon} href="/gallery"/>
        <DemoHomePageCard text="Analyse ergonomique" Icon={UserIcon} href="/ergonomics/live"/>
        <DemoHomePageCard text="Captation du savoir-faire" Icon={BookOpenIcon} href="/recorder/get-stream"/>
      </div>
    </div>
  );
};